var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * Copyright 2019, SumUp Ltd.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { forwardRef } from 'react';
import { css } from '@emotion/react';
import styled from '../../styles/styled';
import { CLASS_DISABLED } from './constants';
const wrapperStyles = () => css `
    &.${CLASS_DISABLED} {
      pointer-events: none;
    }
  `;
const Wrapper = styled('div')(wrapperStyles);
/**
 * @private
 */
export const FieldWrapper = forwardRef((_a, ref) => {
    var { children, disabled, className = '' } = _a, props = __rest(_a, ["children", "disabled", "className"]);
    return (_jsx(Wrapper, Object.assign({ ref: ref, className: disabled ? `${className} ${CLASS_DISABLED}` : className }, props, { children: children })));
});
FieldWrapper.displayName = 'FieldWrapper';
